module.exports = __webpack_public_path__ + "img/yishi13.e82b46a1.jpg";